export default __webpack_public_path__ + "static/media/1.90c9c56b.webp";